import React from 'react';
import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {
  MainMenuFor,
  MenuFor,
  LabelFor,
  DropdownMainMenu,
} from '@/views/Layout/internal/InternalNavBar/detectMenu';

const SubsystemNavContent = () => (
  <div className={styles.megamenu}>
    <LabelFor
      name='subsystemRevenueAndSettlement'
      label='Revenue & Settlement'
    />
    <ul>
      <li>
        <MenuFor name='subsystemRevenue' type='subMenu' label='Revenue' />
        <br />
        <MenuFor
          name='subsystemPayinSettlement'
          type='subMenu'
          label='Payin Settlement'
        />
        <br />
        <MenuFor
          name='subsystemPayoutSettlement'
          type='subMenu'
          label='Payout Settlement'
        />
      </li>
    </ul>
    <br />
    <LabelFor name='subsystemPayment' label='Payment' />
    <ul>
      <li>
        <MenuFor
          name='subsystemHoldPayment'
          type='subMenu'
          label='Hold Payment'
        />
        <MenuFor name='subsystemAddHoldPayment' type='subMenu' label=' / Add' />
      </li>
    </ul>
    <br />
    <LabelFor name='subsystemStatement' label='Statement' />
    <ul>
      <li>
        <MenuFor name='subsystemStatementList' type='subMenu' label='List' />
        <MenuFor
          name='subsystemStatementHistory'
          type='subMenu'
          label=' / History'
        />
      </li>
    </ul>
  </div>
);

const SubsystemNav = () => (
  <MainMenuFor name='subsystem'>
    <DropdownMainMenu name='subsystem' label='Subsystem'>
      <SubsystemNavContent />
    </DropdownMainMenu>
  </MainMenuFor>
);

export default SubsystemNav;
